<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">{{this.$route.name}}</div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-md-4">
            <table>
              <tr>
                <td>
                  <a @click="exportReport()" class="btn-primary mr-5">
                    <i class="far fa-file-alt mr-5"></i>Export
                  </a>
                </td>
                <td>
                  <flat-pickr
                    @on-change="changeDate"
                    :config="exportConfig"
                    class="font-13"
                    v-model="exportDates"
                    name="export_date_start"
                  ></flat-pickr>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-right">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">Coaches</div>
              <div class="col-sm-8">
                <b-form-select name="coaches" v-validate="'required'" @change="changeCoaches" v-model="coaches_id">
                  <option :value="null">Please select</option>
                  <option v-for="item in optCoaches" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-15 pt-0">
        <table class="table b-table table-striped table-hover">
          <thead>
            <tr>
              <th>Instructor Name</th>
              <th>Class Name</th>
              <th>Class Day</th>
              <th>Total Attendance</th>
              <th>Total Comission (Rp)</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="row in items">
              <tr :key="row.id">
                <td>{{ row.coach_name }}</td>
                <td>{{ row.class_name }}</td>
                <td>{{row.class_day}}</td>
                <td>{{row.total_attendance}}</td>
                <td>
                  {{ 'Rp. ' + parseFloat(row.comission).toLocaleString("id-ID", { maximumFractionDigits: 2 }) }}
                </td>
              </tr>
              <tr :key="row.id">
                <td colspan="5">
                  <table class="table">
                    <thead>
                      <tr>
                        <th
                          class="text-uppercase"
                          v-for="(key, val) in row.data[0]"
                          :key="key"
                        >{{ val.replace('_', ' ') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in row.data" :key="index">
                        <td v-for="(val, key) in item" :key="key">{{val}}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </template>
          </tbody>
        </table>

      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import moment from "moment";
import axios from "axios";
import { Auth } from "@/api";
import Pagination from "@/views/component/pagination";

export default {
  name: "gfCommision",
  components: {
    "app-pagination": Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: "coach_name",
          label: "Instructor Name",
          sortable: false
        },
        {
          key: "class_name",
          label: "Class Name",
          sortable: false
        },
        {
          key: "class_day",
          label: "Class Day",
          sortable: false
        },
        {
          key: "detail",
          label: "Detail",
          sortable: false
        },
        {
          key: "total_attendance",
          label: "Total Attendance",
          sortable: false
        },
        {
          key: "comission",
          label: "Total Comission (Rp)",
          formatter: (value, key, item) => {
            return (
              "Rp. " +
              parseFloat(item.comission).toLocaleString("id-ID", {
                maximumFractionDigits: 2
              })
            );
          },
          sortable: false
        }
      ],
      config: {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d"
      },
      exportDates:
        moment()
          .startOf("month")
          .format("YYYY-MM-DD") +
        " to " +
        moment()
          .endOf("month")
          .format("YYYY-MM-DD"),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [
          moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          moment()
            .endOf("month")
            .format("YYYY-MM-DD")
        ]
      },
      items: [],
      dataBranch: [],
      branch_id: null,
      getId: Auth.Session.get().paradigm_id,
      sortType: "",
      sortBy: "",
      searchData: "",
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      coaches_id: null,
      optCoaches: []
    };
  },
  computed: {
    name() {
      return this.$route.name;
    }
  },
  methods: {
    changeCoaches(event) {
      this.fetchData();
    },
    changeDate(selectedDates, dateStr, instance) {
      this.exportDates = dateStr;
      if (this.exportDates.includes(" to ") === true) {
        this.fetchData();
      }
    },
    parseCalc(event) {
      return Math.ceil(event);
    },
    parseDate(value) {
      moment.locale("en");
      return moment(value).format("DD MMMM YYYY");
    },
    parseTime(value) {
      moment.locale("en");
      return moment(value).format("h:mm a");
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum;
      this.fetchData();
    },
    sortingChanged(event) {
      this.sortBy = event.sortBy;
      if (event.sortDesc === false) {
        this.sortType = "asc";
      } else {
        this.sortType = "desc";
      }
      this.fetchData();
    },
    enterClicked(searchEvent) {
      this.fetchData();
    },
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "danger"
        : status === "active"
        ? "success"
        : status === "inactive"
        ? "danger"
        : "primary";
    },
    openPage(event) {
      this.$router.push(event);
    },
    editForm(event) {
      this.$router.push(event);
    },
    showModal(id) {
      this.$refs[id].show();
    },
    deleteForm(event) {
      this.$swal({
        title: "Are you sure?",
        text: "You can't revert your action",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes Delete it!",
        cancelButtonText: "No, Keep it!",
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then(result => {
        if (result.value) {
          this.$swal(
            "Deleted",
            "You successfully deleted this file",
            "success"
          );
          axios.defaults.headers.common[
            "X-Access-Token"
          ] = Auth.Session.get().paradigm_token;
          axios
            .delete("fitness/v1/form/".concat(event))
            .then(response => {
              this.fetchData();
            })
            .catch(error => {
              console.log("error", error);
            });
        } else {
          this.$swal("Cancelled", "Your file is still intact", "info");
        }
      });
    },
    exportReport() {
      let dates = this.exportDates.split(" to ");
      let years = moment(dates[0]).format("YYYY");
      let month = moment(dates[0]).format("MM");
      let url = "fitness/v1/export/summary?years=" + years
        +"&month=" + month
        +"&coaches_id=" +this.coaches_id

      axios({
        method: "get",
        url: url,
        responseType: "arraybuffer"
      })
        .then(response => {
          let blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download =
            "Group Fitness Summary Detail " +
            moment(dates[0]).format("DD-MMM-YYYY") +
            " - " +
            moment(dates[1]).format("MMM-YYYY") +
            ".xlsx";
          link.click();
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    changeBranch(event) {
      this.coaches_id = null
      let url = "fitness/v1/coaches/show"

      if (event != "") {
        url += '?branch_id=' + event
      }

      axios.get(url).then(response => {
        this.optCoaches = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchData() {
      let dates1 = this.exportDates.split(" to ");
      let years = moment(dates1[0]).format("YYYY");
      let month = moment(dates1[0]).format("MM");
      let url_summary = "fitness/v1/group_fitness/summary?years=" + years
        + "&month=" +month
        + "&coaches_id=" +this.coaches_id

      axios.get(url_summary)
        .then(response => {
          this.items = response.data;
          console.log(response.data);
        })
        .catch(error => {
          console.log("error", error);
        });

      let url = "fitness/v1/coaches/show"

      if (this.branch_id != "") {
        url += '?branch_id=' + this.branch_id
      }

      axios.get(url).then(response => {
        this.optCoaches = response.data.data.rows;
      }).catch(error => {
        console.log("error", error);
      });

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style>
</style>
